<template>
    <crud 
        :action-icon='actionIcon'
        :model-def='modelDef'
        :action-position='actionPosition'
        :speed-dial-options="speedDialOptions"
        :title="title"
    ></crud>
</template>

<script>
export default {
	name: 'index',
	data() {
		return {}
	},

	props: {
		title: String,
		actionIcon: String,
		modelDef: String,
		defaultInput: Object,
		actionPosition: {
			default: 'fixed',
			type: String
		},
		speedDialOptions: Object
	}
}
</script>
